import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from '../../../asterX-UI'

export const useStyles = makeStyles(theme => ({
  filter: {
    padding: '8px',
    backgroundColor: 'white',
    borderRadius: 8
  },
  checkbox: {
    marginLeft: 0,
    marginRight: 0,
    padding: '12px 16px',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 12,
    '& .MuiButtonBase-root': {
      padding: '0 9px 0 0'
    }
  }
}))
